// src/components/HelpButton.js
import React from "react";

const HelpButton = () => {
  const openHelp = () => {
    window.open(
      "https://notebooklm.google.com/notebook/91ad66f4-db7a-41e1-b490-fd8fa31c86f1", // <-- Replace with your notebook LM link
      "_blank"
    );
  };

  return (
    <button
      onClick={openHelp}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        padding: "12px 18px",
        backgroundColor: "#007bff",
        color: "#fff",
        fontWeight: "bold",
        border: "none",
        borderRadius: "50px",
        cursor: "pointer",
        zIndex: 1000,
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        transition: "background-color 0.2s ease",
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#0056b3")}
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#007bff")}
    >
      FM Bot(Help)
    </button>
  );
};

export default HelpButton;
